/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Saveerror2Inputs */

const en_settings_collaborators_manageroles_saveerror2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Saveerror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update roles. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to update roles. Please try again." |
*
* @param {Settings_Collaborators_Manageroles_Saveerror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_saveerror2 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Saveerror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Saveerror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_saveerror2(inputs)
});
export { settings_collaborators_manageroles_saveerror2 as "settings_collaborators_manageRoles_saveError" }